import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { Instagram, Facebook, Youtube } from "lucide-react";
import NewsletterSignup from "./NewsletterSignup";

export const SOCIAL_LINKS = [
  { href: "https://www.instagram.com/amazonico3000/", label: "Instagram", icon: Instagram, testid: "social-instagram" },
  { href: "https://www.facebook.com/profile.php?id=61574281947800", label: "Facebook", icon: Facebook, testid: "social-facebook" },
  { href: "https://www.youtube.com/@AMAZONICO3000", label: "YouTube", icon: Youtube, testid: "social-youtube" },
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-24 border-t border-border bg-[hsl(var(--muted))]">
      <div className="container-xl py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <img src="/brand/logo.png" alt="Amazonico 3000" className="h-20 w-auto" />
          <p className="mt-4 text-sm text-muted-foreground max-w-sm">
            {t("tagline", "Il gusto autentico d'Italia, dal produttore a te")}
          </p>
          {/* Social icons */}
          <div className="mt-6 flex items-center gap-3" data-testid="footer-social">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.href}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={s.testid}
                className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-border text-muted-foreground hover:bg-[hsl(var(--primary))] hover:text-white hover:border-[hsl(var(--primary))] transition-colors"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-foreground mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/vini" className="hover:text-foreground">Vini</Link></li>
            <li><Link to="/box" className="hover:text-foreground">Food Box</Link></li>
            <li><Link to="/esperienze" className="hover:text-foreground">Esperienze</Link></li>
            <li><Link to="/tv" className="hover:text-foreground">Amazonico TV</Link></li>
            <li><Link to="/ai-ricette" className="hover:text-foreground">AI Ricette</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-foreground mb-3">B2B & Club</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/b2b" className="hover:text-foreground">Marketplace B2B</Link></li>
            <li><Link to="/b2b/sommelier" className="hover:text-foreground">AI Sommelier</Link></li>
            <li><Link to="/club" className="hover:text-foreground">Club Privilegia</Link></li>
            <li><Link to="/abbonamenti" className="hover:text-foreground">Abbonamenti</Link></li>
            <li><Link to="/franchising" data-testid="footer-franchising" className="hover:text-foreground">Apri il tuo franchising</Link></li>
            <li><Link to="/pitch" data-testid="footer-pitch" className="hover:text-foreground">Pitch · Investor & Partner</Link></li>
            <li><Link to="/media-kit" data-testid="footer-media-kit" className="hover:text-foreground">Amazonico TV · Sponsorship</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-foreground mb-3">Supporto</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/supporto" className="hover:text-foreground">FAQ</Link></li>
            <li><Link to="/supporto" className="hover:text-foreground">Spedizioni</Link></li>
            <li><Link to="/supporto" className="hover:text-foreground">Resi</Link></li>
            <li><Link to="/supporto" className="hover:text-foreground">Contatti</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link></li>
            <li><Link to="/cookie" className="hover:text-foreground">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>

      {/* Inline newsletter */}
      <div className="border-t border-border">
        <div className="container-xl py-8 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-bold mb-1">Newsletter</div>
            <div className="editorial-heading text-xl md:text-2xl">Iscriviti alla newsletter</div>
            <p className="text-xs md:text-sm text-muted-foreground mt-1">Un episodio TV, 3 vini in evidenza, un'esperienza prenotabile — ogni settimana.</p>
          </div>
          <NewsletterSignup variant="inline" source="footer" />
        </div>
      </div>
      <div className="border-t border-border py-6">
        <div className="container-xl flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© 2026 Amazonico 3000. {t("footer.rights", "Tutti i diritti riservati")}</span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
            <Link to="/cookie" className="hover:text-foreground">Cookie</Link>
            <span>Milano · Italia</span>
            <span className="hidden md:inline text-border">·</span>
            <div className="flex items-center gap-2">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={`bottom-${s.href}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="hover:text-[hsl(var(--primary))] transition-colors"
                >
                  <s.icon className="h-3.5 w-3.5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
